import { render, staticRenderFns } from "./HqPackingListProductListCopy.vue?vue&type=template&id=267cefdc&scoped=true"
import script from "./HqPackingListProductListCopy.vue?vue&type=script&lang=ts"
export * from "./HqPackingListProductListCopy.vue?vue&type=script&lang=ts"
import style0 from "./HqPackingListProductListCopy.vue?vue&type=style&index=0&id=267cefdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267cefdc",
  null
  
)

export default component.exports